export const state = () => ({
  config: {
    nav: [
      {
        title: "首页",
        href: "/",
        activeReg: /(^\/search*)|(^\/$)/,
      },
      {
        title: "交易公开",
        href: "/trade",
        activeReg: /(^\/trade)|(^\/$)/,
      },
      {
        title: "行业动态",
        href: "/industryTrends",
        activeReg: /(^\/industryTrends)|(^\/$)/,
      },
      {
        title: "政策法规",
        href: "/policiesList",
        activeReg: /(^\/policiesList)|(^\/$)/,
      },
      {
        title: "下载中心",
        href: "/download",
        activeReg: /(^\/download)|(^\/$)/,
      },
      {
        title: "关于我们",
        href: "/about",
        activeReg: /(^\/about)|(^\/$)/,
      },
      {
        title: "银川城发供应链",
        href: "https://scm.yccfgyl.com/#/home",
        isExternalLink:true,
        activeReg: /(^\/cfgyl)|(^\/$)/,
      },
    ],
    baseInfo: {
      businessAddress: "呼和浩特市新城区成吉思汗大街琦琳北辰C座12楼",
      //   businessTime: "法定工作日 8:30-11:30 14:30-17:30",
      //   companyName: "河北建设投资集团有限责任公司",
      companyNameUrl: "www.nmgbyxs.com",
      complainEmail: "nmgyxxg@163.com",
      //   recordCode: "冀ICP备15007930号-1",
      //   recordUrl: "冀公网安备13010402001349号",
      serveEmail: "service@jtsww.com",
      servePhone: "0471-8321678",
      //   siteCertification: "中国金融认证中心",
    },
    friendshiplink: {},
  },
});

export const mutations = {
  setBaseInfo(state, val) {
    state.config.baseInfo = val;
  },
  setLinks(state, val) {
    state.config.friendshiplink = val;
  },
};
